import './App.css';
import PlayerArea from '../src/Components/PlayerArea/PlayerArea'

function App() {
  return (
    <div>
      <PlayerArea></PlayerArea>
    
    </div>
  );
}

export default App;
